export default {
  "title": {
    "tasks_traceability": "Trazabilidad de desviaciones",
    "notifications_traceability": "Trazabilidad de notificaciones"
  },
  "labels": {
    "totalTasks": "Cantidad de tareas"
  },
  "table": {
    "occurrenceDate": "Ocurrencia",
    "createdDate": "Creación",
    "closedDate": "Cierre",
    "type": "Tipo",
    "subtype": "Subtipo",
    "person": "Trabajador",
    "vehicle": "Vehículo",
    "accountable": "Responsable",
    "manager": "Gestión por",
    "state": "Estado",
    "noData": "No hay más datos"
  },
  "tooltip": {
    "occurrenceDate": "Corresponde a la fecha y hora exacta en la que ocurrió la desviación.",
    "createdDate": "Corresponde a la fecha en que la desviación se creó en el sistema Gauss Control.",
    "closedDate": "Corresponde a la fecha en que la desviación fue gestionada.",
    "type": "Corresponde al tipo al que aplica la desviación. Por ejemplo: Cumplimiento legal, distracción, evento de fatiga, entre otros.",
    "subtype": "Corresponde al subtipo al que aplica la desviación. Por ejemplo si el tipo es cumplimiento legal, sus subtipos son: descanso diario incumplido, sobrehora jornada, entre otros.",
    "person": "Corresponde al trabajador que incurrió en el incumplimiento o evento generando la desviación.",
    "vehicle": "Corresponde a la patente del vehículo utilizado. Sólo aplica para desviaciones que involucran conducción.",
    "accountable": "Corresponde a la persona(s) responsable(s) de gestionar la desviación.",
    "manager": "Corresponde a la persona que gestionó la desviación.",
    "desvHelp1": "Corresponde al estado de gestión de la desviación.",
    "desvCat1Label": "Abiertas:",
    "desvCat2Label": "Cerradas a tiempo:",
    "desvCat3Label": "Cerradas vencidas:",
    "desvCat4Label": "Vencidas:",
    "desvCat5Label": "Anuladas:",
    "desvCat6Label": "Notificaciones:",
    "desvCat1LabelDesc": "desviaciones que aun no han sido gestionadas pero que se encuentran dentro del plazo.",
    "desvCat2LabelDesc": "desviaciones que fueron gestionadas dentro del plazo establecido.",
    "desvCat3LabelDesc": "desviaciones que fueron gestionadas fuera del plazo establecido.",
    "desvCat4LabelDesc": "desviaciones que aun no han sido gestionadas y cuyo plazo venció.",
    "desvCat5LabelDesc": "desviaciones cuyos eventos correspondían a falsos positivos por lo tanto fueron anuladas del sistema por el encargado de la gestión.",
    "desvCat6LabelDesc": "desviaciones cuyos eventos no requieren una gestión."
  },
  "filters": {
    "type": "Tipo",
    "state": "Estado",
    "person": "Trabajador",
    "vehicle": "Vehículo",
    "accountable": "Responsable",
    "manager": "Gestión por",
    "geoZone": "Geozona",
    "all": "Todos",
    "stateOptions": {
      "": "Todos",
      "Abierta": "Abierta",
      "Cerrada": "Cerrada",
      "Cerrada vencida": "Cerrada vencida",
      "Vencida": "Vencida"
    },
    "annulTasks": "Anular tareas",
    "show": "Mostrar",
    "subtype": "Subtipo",
    "workingShiftGroup": "Grupo de turno"
  },
  "states": {
    "CLOSED": "Cerrada a tiempo",
    "OPEN": "Abierta",
    "OVERDUE": "Vencida",
    "CLOSEDOVERDUE": "Cerrada vencida",
    "ANNULLED": "Anulada",
    "NOTIFICATION": "Notificación",
    "PENDINGRECLASIFICATION": "Pendiente reclasificación"
  },
  "taskform": {
    "description": "Descripción",
    "taskCreationDate": "Fecha de creación",
    "download": "Descargar",
    "downloading": "Descargando",
    "downloadErrorMediaTitle": "Error al descargar",
    "downloadErrorMediaDescription": "Ha ocurrido un error al descargar el archivo, vuelva a intentarlo.",
    "fileNotUploaded": "No se subió archivo",
    "save": "Cerrar tarea",
    "closed": "Tarea cerrada",
    "taskInformation": "Información de la tarea",
    "taskManagement": "Gestión de la tarea",
    "dueDate": "Fecha de vencimiento",
    "eventDate": "Fecha evento",
    "taskCloseDate": "Fecha de cierre",
    "taskClosed": "Tarea cerrada",
    "next": "Siguiente",
    "back": "Anterior",
    "plate": "Patente",
    "driver": "Conductor",
    "BREATHALYSER": "Alcotest",
    "PVTTEST": "PVT",
    "FORM": "Encuesta",
    "detail": "Detalle",
    "loadingOptions": "Cargando opciones.",
    "loadingOptionsError": "Error al cargar opciones, vuelva a cargar la desviación.",
    "loadingMedia": "Cargando archivo.",
    "loadingMediaError": "Error al cargar archivo, vuelva a cargar la desviación.",
    "actions": {
      "Reclassify": "Re-clasificar tarea",
      "Annul": "Anular tarea",
      "Close": "Finalizar tarea",
      "Save": "Guardar borrador de tarea"
    },
    "actionsResults": {
      "Reclassify": "Desviación re-clasificada",
      "Annul": "Desviación anulada",
      "Close": "Desviación cerrada",
      "Save": "Desviación guardada"
    },
    "invalid": "Debes completar este campo para cerrar la desviación.",
    "showDescription": "ver descripción",
    "hideDescription": "ocultar descripción",
    "goBack": "Volver",
    "withoutDeviationInformation": "No se encontró información relacionada a la desviación"
  },
  "excel": {
    "downloadExcel": "Descargar datos en archivo Excel",
    "downloadSummaryExcel": "Descargar datos resumidos",
    "downloadNoProcessExcel": "Descargar datos sin procesar",
    "downloadFileNameSummary": "datos_gestionador_resumen",
    "downloadFileNameNoProcess": "datos_gestionador_no_procesados",
    "downloadErrorDateRangeTitle": "Rango de fechas de descarga no permitido",
    "downloadErrorDateRangeDescription": "Ha excedido el rango de fechas de descarga permitido (3 meses o menos). Para solicitar un informe que contemple un período mayor a 3 meses, por favor, contacte a la mesa de ayuda de Gauss Control.",
    "downloadingTitle": "Descargando reporte",
    "downloadingPleaseWait": "Procesando su descarga, esta operación podría tomar varios minutos..."
  },
  "feedback": {
    "maxToAnnulReached": "Se ha superado el número máximo de desviaciones que pueden ser seleccionadas para anular.",
    "nothingSelectedToAnnul": "Debe seleccionar a lo menos una desviación para anular.",
    "annulSuccess": "Desviaciones anuladas exitosamente",
    "annulError": "Ha ocurrido un error al intentar anular las desviaciones. Vuelva a intentarlo.",
    "editSuccess": "Desviación modificada exitosamente",
    "editError": "Ha ocurrido un error al intentar modificar la desviación. Vuelva a intentarlo."
  },
  "annulConfirm": {
    "confirmButton": "Si",
    "cancelButton": "No",
    "question": "¿Estás seguro de que quieres anular estas desviaciones?",
    "warning": "Al anular una desviacion ya no sera posible aplicar la gestión correspondiente.",
    "questionSingle": "¿Estás seguro de anular esta desviación?",
    "warningSingle": "Al realizar esta acción la desviación quedará inactiva en el sistema y no se podrá volver a activar para aplicar una gestión."
  },
  "topCharts": {
    "tasksByState": "Distribución de tareas por estado",
    "totalTasks": "Total",
    "manageTasks": "Tareas de gestión",
    "notifications": "Notificaciones"
  },
  "driverErrorAlert": {
    "confirmButton": "¡Entendido!",
    "title": "Según el sistema esta desviación corresponde a otro trabajador",
    "line1a": "Se ha identificado que esta desviación pertenece al trabajador",
    "line1b": ", el cual no corresponde con la selección de trabajador realizada.",
    "line2": "El sistema Gauss Control asignó de forma previa el trabajador al que pertenece esta desviación. Gracias a la información obtenida de distintas fuentes de datos es posible identificar y asignar de forma automática a las personas correspondientes.",
    "line3": "Actualice la plataforma para restablecer la información."
  },
  "tab": {
    "not_tabs_assigned": "No tiene pestañas asignadas",
    "tasks": "Desviaciones",
    "notifications": "Notificaciones",
    "detail": "Detalle"
  },
  "redirectDetail": {
    "sessionExpiredTitle": "Sesión expirada",
    "sessionExpiredMessage": "Abra nuevamente el enace que le proporcionamos para iniciar sesión y acceder a su cuenta."
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/escondida/task_manager/taskManager.js